<template>
  <section class="clients-say-section">
    <div class="section-container">

      <div class="header">
        <div class="tag">+ CLIENT FEEDBACK</div>
        <h2 class="title">What Our <span class="gradient">Clients Say</span></h2>

        <div class="divider-container">
          <div class="line"></div>
          <span class="square-icon">[■]</span>
          <div class="line"></div>
        </div>
      </div>

      <div class="grid">
        <div v-for="client in clients" :key="client.name" class="card">
          <div class="stars">★★★★★</div>

          <p class="content">{{ client.text }}</p>

          <div class="footer">
            <div class="user-info">
              <span class="flag">{{ client.flag }}</span>
              <div class="user-text">
                <div class="name">{{ client.name }}</div>
                <div class="location">{{ client.location }}</div>
              </div>
            </div>

            <div class="verified">
              <span class="check-icon">✓</span> VERIFIED
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'ClientsSaySection',
  data() {
    return {
      clients: [
        {
          flag: '🇺🇸',
          name: 'James Harrington',
          location: 'UNITED STATES · BTC RECOVERY',
          text: 'I lost over $45,000 to a fake crypto investment platform. Fraud Counsel traced every transaction and helped me file an enforcement case. Their process was thorough and professional from start to finish. I genuinely cannot thank them enough.'
        },
        {
          flag: '🇸🇬',
          name: 'David Tan Wei',
          location: 'SINGAPORE · USDT RECOVERY',
          text: 'Their blockchain intelligence tools tracked my stolen USDT across four different wallets and two exchanges. The team coordinated directly with the platforms and the recovery was completed within the week. Truly world-class service.'
        },
        {
          flag: '🇯🇵',
          name: 'Kenji Yamamoto',
          location: 'JAPAN · ETH RECOVERY',
          text: 'After a DeFi exploit took everything, Fraud Counsel analysed the smart contract, traced the developer wallets, and built a case that authorities were able to act on. Their understanding of DeFi fraud is comprehensive and highly specialised.'
        }
      ]
    };
  }
}
</script>

<style scoped>
.clients-say-section {
  background-color: #070b14;
  padding: 60px 5%;
  color: #e2e8f0;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
}

.header {
  margin-bottom: 50px;
}

.tag {
  color: #4fd1c5;
  font-size: 0.75rem;
  letter-spacing: 2px;
  margin-bottom: 10px;
  font-weight: 500;
}

.title {
  font-size: 2.6rem;
  font-weight: 700;
  margin: 0 0 20px;
}

.gradient {
  background: linear-gradient(90deg, #4fd1c5, #8be9fd);
  -webkit-background-clip: text;
  color: transparent;
}

.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.divider-container .line {
  flex: 1;
  height: 1px;
  background-color: rgba(79, 209, 197, 0.2);
}

.divider-container .square-icon {
  color: #4fd1c5;
  font-size: 0.8rem;
  font-family: monospace;
  margin: 0 15px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
}

.card {
  background: #0d1117;
  border: 1px solid rgba(37, 48, 69, 0.8);
  border-radius: 8px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s, border-color 0.3s;
}

.card:hover {
  border-color: #4fd1c5;
  transform: translateY(-5px);
}

.stars {
  color: #fbbf24;
  font-size: 1.1rem;
  margin-bottom: 25px;
  letter-spacing: 2px;
}

.content {
  color: #94a3b8;
  font-size: 0.9rem;
  line-height: 1.8;
  margin-bottom: 30px;
  flex: 1;
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-top: 1px solid rgba(37, 48, 69, 0.6);
  padding-top: 20px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.flag {
  font-size: 2rem;
}

.user-text {
  text-align: left;
}

.name {
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
}

.location {
  color: #94a3b8;
  font-size: 0.75rem;
  letter-spacing: 1px;
}

.verified {
  color: #4fd1c5;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 5px;
}

.check-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 12px;
  height: 12px;
  border: 1px solid #4fd1c5;
  border-radius: 50%;
  font-size: 0.6rem;
}


@media (max-width: 900px) {
  .grid {
    grid-template-columns: 1fr;
  }

  .title {
    font-size: 2.2rem;
  }
}
</style>